<template>
  <div class="main-results" v-if="!isLeftClick ">
    <div class="main-results-all" v-for="(item,index) in resultsData.obj" :key="index">
      <div class="main-results-name">
        <img v-if="paper[item.resourceCode] === '项目'" src="static/img/icon/project.png" />
        <img v-else-if="paper[item.resourceCode] === '专利'" src="static/img/icon/patent.png" />
        <img v-else-if="paper[item.resourceCode] === '图书'" src="static/img/icon/books.png" />
        <img v-else-if="paper[item.resourceCode] === '成果奖励'" src="static/img/icon/reward.png" />
        <img v-else-if="paper[item.resourceCode] === 'Sci'" src="static/img/icon/sci.png" />
        <img v-else-if="paper[item.resourceCode] === 'Ei'" src="static/img/icon/EI.png" />
        <img v-else src="static/img/icon/papers.png" />
        <el-popover
          ref="popover"
          popper-class="detail-pop"
          v-if="item.resourceCode === 'J' || item.resourceCode === 'I'"
          placement="right-start"
          @show="getAbs(item.resourceCode,item.resourceId,index)"
          title="摘要"
          width="500"
          trigger="hover"
        >
          <div v-loading="loading" style="text-indent: 2em;">{{abs}}</div>
          <div
            slot="reference"
            @click="goUrl(item.url,item.doi)"
            :style="item.url || item.doi?'cursor:pointer':''"
          >{{item.title}}</div>
        </el-popover>
        <span
          v-else
          @click="goUrl(item.url,item.doi)"
          :style="item.url || item.doi?'cursor:pointer':''"
        >{{item.title}}</span>
      </div>
      <div class="main-results-title">
        <span
          v-if="paper[item.resourceCode] === '项目'"
        >{{item.year ? '年份：('+item.year+')':''}} {{item.projectOrigin ? '项目类型：'+item.projectOrigin:''}}</span>
        <span
          v-else-if="paper[item.resourceCode] === '专利'"
        >{{item.patentNo ? '专利编号：'+ item.patentNo:''}} {{item.type ? '专利类型：'+ item.type:''}}</span>
        <span v-else-if="paper[item.resourceCode] === '图书'">{{item.isbn ? 'ISBN: ' + item.isbn:''}}</span>
        <span
          v-else-if="paper[item.resourceCode] === '成果奖励'"
        >{{item.creatorAll ? '成员：' + item.creatorAll:''}}</span>
        <span
          v-else
        >{{item.year ? '发表年份:' + item.year :''}}{{item.journal ? ' 发表期刊：' + item.journal:''}}</span>
      </div>
      <div class="main-results-label">
        <span v-if="paper[item.resourceCode] === '项目'">{{item.creator ? '项目负责人:' + item.creator:''}}</span>
        <span
          v-if="paper[item.resourceCode] === '项目'"
          class="creatorAll"
          :title="item.creatorAll"
        >{{item.creatorAll ? '项目成员:' + item.creatorAll:''}}</span>
        <span
          v-else-if="paper[item.resourceCode] === '专利'"
        >{{item.applicationNo ? '申请编号：' + item.applicationNo:''}} {{item.applicationDate ? '申请时间：'+item.applicationDate:""}}</span>
        <span
          v-else-if="paper[item.resourceCode] === '图书'"
        >{{item.creator ? '作者:' + item.creator:''}}</span>
        <span
          v-else-if="paper[item.resourceCode] === '成果奖励'"
        >{{item.instituteStandard ? '归属机构： ' + item.instituteStandard:''}}</span>
        <span v-else>{{item.creatorAll ? '作者:' + item.creatorAll:''}}</span>
      </div>
      <div class="main-results-label">
        <span
          v-if="paper[item.resourceCode] === '项目'"
        >{{item.instituteStandard ? '项目归属机构：' + item.instituteStandard:''}}</span>
        <span
          v-else-if="paper[item.resourceCode] === '专利'"
        >{{item.creatorAll ? '申请人：' + item.creatorAll:''}}</span>
        <span
          v-else-if="paper[item.resourceCode] === '图书'"
        >{{!item.page || item.page === 'null'? '':'总页数: ' + item.page}}</span>
        <span v-else-if="paper[item.resourceCode] === '成果奖励'">{{item.type ? '成果类型： ' +item.type:''}}</span>
        <span v-else>{{item.instituteStandard ? '单位：'+item.instituteStandard:''}}</span>
      </div>
      <div class="main-results-label">
        <div v-if="paper[item.resourceCode] === '中文论文'">
          <span>学科：{{item.subject}}</span>
        </div>
      </div>
      <div class="main-results-label">
        <div v-if="paper[item.resourceCode] === '项目'">
          <div v-if="keyword && item.keyword">
            <span>{{item.keyword ? '关键词：':''}}</span>
            <span v-for="(item, index) in item.keyword.split(';')" :key="index">
              <b v-html="$options.filters.colors(item,keyword)"></b>;
            </span>
            <!-- :style=" item | colors(keyword) " -->
          </div>
          <div v-else>
            <span>{{item.keyword?'关键词：'+item.keyword:''}}</span>
          </div>
        </div>
        <span
          v-else-if="paper[item.resourceCode] === '专利'"
        >{{item.instituteStandard ? '申请单位：' + item.instituteStandard:''}}</span>
        <span v-else-if="paper[item.resourceCode] === '图书'"></span>
        <span
          v-else-if="paper[item.resourceCode] === '成果奖励'"
        >{{item.subject ? '所属领域： ' + item.subject:''}}</span>
        <div v-else>
          <div v-if="keyword && item.keyword">
            <span>{{item.keyword ? '关键词：':''}}</span>
            <span v-for="(item, index) in item.keyword.split(';')" :key="index">
              <b v-html="$options.filters.colors(item,keyword)"></b>;
            </span>
            <!-- :style="item | colors(keyword) " -->

            <!-- item.indexOf(keyword) != -1 ?'red':'' -->
          </div>
          <div v-else>
            <span>{{item.keyword?'关键词：'+item.keyword:''}}</span>
          </div>
        </div>
      </div>
      <div class="main-results-label">
        <span v-if="paper[item.resourceCode] === '项目'"></span>
        <span
          v-else-if="paper[item.resourceCode] === '专利'"
        >{{item.domain ? '归属行业：' + item.domain:''}}</span>
        <span v-else-if="paper[item.resourceCode] === '图书'"></span>
        <div v-else-if="paper[item.resourceCode] === '成果奖励'">
          <div v-if="keyword && item.keyword">
            <span>{{item.keyword ? '关键词：':''}}</span>
            <span v-for="(item, index) in item.keyword.split(';')" :key="index">
              <b v-html="$options.filters.colors(item,keyword)"></b>;
            </span>
            <!-- :style="item | colors(keyword)" -->
          </div>
          <div v-else>
            <span>{{item.keyword?'关键词：'+item.keyword:''}}</span>
          </div>
        </div>
        <span v-else></span>
      </div>
      <div class="main-results-label">
        <span v-if="paper[item.resourceCode] === '项目'"></span>
        <span v-else-if="paper[item.resourceCode] === '专利'"></span>
        <span v-else-if="paper[item.resourceCode] === '图书'"></span>
        <span v-else-if="paper[item.resourceCode] === '成果奖励'">{{item.year ? '年份：' + item.year:''}}</span>
        <span v-else></span>
      </div>

      <div
        class="main-results-operation"
        @click="goUrl(item.url,item.doi)"
        v-if="item.url || item.doi"
        style="cursor:pointer"
      >
        <!-- <span style="margin-right:10px">CITATIONS*(6,016)</span>
        <img src="static/img/icon/download.png" />-->

        <img src="static/img/icon/share.png" />
        <span>原文链接</span>
        <!-- <img src="static/img/icon/books2.png" />
        <img src="static/img/icon/download.png" />-->
      </div>
    </div>

    <pagination
      :total="resultsData.total"
      :page.sync="pageData.PageIndex"
      :limit.sync="pageData.PageSize"
      :pageSizes="pageSizes"
      @pagination="getPage()"
    />
    <p class="cup" @click="showUs" style="text-align:right;">如需获取详细资料欢迎和我们联系</p>
  </div>
  <div v-loading="true" v-else class="main-results"></div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { getPaperAbstract } from '@/api/detail'
// 定义一个 Vue 全局的过滤器，名字叫做  msgFormat
export default {
  filters: {
    colors (item, keyword) {
      if (item.indexOf('_') > -1) {
        let str = ''
        let arr = item.split('_')
        arr.map((el, i) => {
          if (i == 1 || i == 3 || i == 5 || i == 7 || i == 9) {
            str += `<em>${arr[i]}</em>`
          } else {
            str += el
          }
        })
        return str
      } else {
        return item
      }
    }
  },
  name: 'Menu1',
  props: {
    resultsData: {
      type: Object,
      required: true
    },
    isLeftClick: {
      type: Boolean
    },
    keyword: {
      type: String
    }
  },

  watch: {
    resultsData: {
      deep: true,
      handler () {
        if (!Object.keys(this.resultsData).length) {
          return
        }
        this.pageData.PageIndex =
          this.resultsData.from / this.resultsData.size + 1

        if (this.resultsData.obj.length) {
          let indexn = this.resultsData.obj.findIndex(
            item => item.resourceCode === 'J'
          )
          let indexm = this.resultsData.obj.findIndex(
            item => item.resourceCode === 'I'
          )
          if (indexn !== -1 || indexm !== -1) {
            // this.getAbstract(this.resultsData.obj[0], 0)
            // this.loading = true
          } else {
            // this.loading = false
          }
        }
      }
    }
  },
  components: {
    Pagination
  },
  data () {
    return {
      pageData: {
        No: '',
        Name: '',
        PageSize: 10,
        PageIndex: 0
      },
      pageSizes: [10],
      paper: {
        O: '项目',
        A: '成果奖励',
        B: '图书',
        E: 'EI',
        P: '专利',
        I: 'Sci',
        J: '中文论文'
      },
      vis: false,
      abstractList: ['', '', '', '', '', '', '', '', '', ''],
      loading: false,
      abs: ''
    }
  },
  mounted () {},
  methods: {
    showUs () {
      this.$store.commit('ContactUs', true)
    },
    // reset () {
    //   let temp = []
    //   this.resultsData.obj.stats1.resource.forEach((item, index) => {
    //     temp[item.code] = temp.name
    //   })
    //   this.resultsData.paper = temp
    // },

    // 成果列表原文跳转
    goUrl (url, doi) {
      if (url) {
        let temp = decodeURIComponent(url)
        let goUrl = ''
        if (temp === url) {
          goUrl = url.split('amp;').join('')
        } else {
          goUrl = temp.split('skipurl=')[1]
        }
        if (url) {
          window.open(goUrl)
        }
      } else if (doi) {
        let goUrl = 'https://doi.org/' + doi
        window.open(goUrl)
      }
    },

    // 页面跳转
    getPage () {
      if (this.pageData.PageIndex > 10) {
        this.pageData.PageIndex = 10
        this.$alert('当前默认显示100条成果，如您需要更多请联系我们。', {
          confirmButtonText: '确定',
          callback: action => {
            this.$store.commit('ContactUs', true)
          }
        })
        return
      }

      let from = (this.pageData.PageIndex - 1) * 10
      this.$emit('menuPage', from)
    },
    // hover (code, id) {
    //   if (code === 'J') {
    //     getPaperAbstract({ id: id }).then(res => {
    //       console.log(res)
    //     })
    //   }
    // },

    //
    // getAbstract (item, index) {
    //   if (index + 1 > this.resultsData.obj.length) {
    //     this.loading = false
    //   } else if (item.resourceCode !== 'J' && item.resourceCode !== 'I') {
    //     this.abstractList[index] = ''
    //     this.getAbstract(this.resultsData.obj[index + 1], index + 1)
    //   } else {
    //     getPaperAbstract({id: item.resourceId}).then(res => {
    //       let temp = ''
    //       if (res.data && res.data.obj.length) {
    //         temp = res.data.obj[0].abstract
    //           ? res.data.obj[0].abstract
    //           : res.data.obj[0].abstractAlt
    //       }
    //       this.abstractList[index] = temp
    //       this.getAbstract(this.resultsData.obj[index + 1], index + 1)
    //     })
    //   }
    // },

    // 成果摘要
    getAbs (code, id, index) {
      this.loading = true
      if (code === 'J' || code === 'I') {
        getPaperAbstract({ id: id }).then(res => {
          let temp = ''
          if (res.data && res.data.obj.length) {
            temp = res.data.obj[0].abstract
              ? res.data.obj[0].abstract
              : res.data.obj[0].abstractAlt
          }
          if (temp) {
            this.abs = temp
          } else {
            this.$refs['popover'][index].doClose()
          }
          this.loading = false
        })
      }
    }
  }
}
</script>

<style lang="scss">
.cup{
  cursor: pointer;
}
.main-results {
  padding: 0 40px;
  min-height: 60vh;
  .main-results-all {
    border-bottom: 1.5px solid #000000;
    margin-top: 40px;
    .main-results-name {
      font-weight: 700;
      height: 40px;
      display: flex;
      align-items: center;
    }
    .main-results-title {
      font-size: 0.85em;
      font-style: oblique;
    }
    .main-results-label {
      font-size: 0.85em;
      margin-top: 10px;
      b {
        font-weight: normal;
      }
      em {
        color: red;
        font-style: normal;
      }
      .creatorAll {
        display: block;
        margin-top: 10px;
        line-height: 2;
        height: 48px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .main-results-btns {
      margin-top: 10px;
    }
    .main-results-introduce {
      padding: 10px 0;
      border-bottom: 1px solid #888888;
    }
    .main-results-operation {
      padding: 20px 0;
      display: flex;
      justify-content: flex-end;
    }
  }

  img {
    margin-right: 10px;
    width: 20px;
    height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/detail/Menu/menu1.vue